import DEVICE_NAME from './DEVICE_NAME.js'
import DEVICE_TYPE from './DEVICE_TYPE.js'
import STORE_NAME from './STORE_NAME.js'

export default Object.freeze({
  DEVICE_NAME,
  DEVICE_TYPE,
  STORE_NAME,
})
